import { Component, Input } from '@angular/core';

// A single figure with its label. The figure is the content, so callers format it:
// <app-kpi-card [label]="..." [clickable]="true" (click)="modal.show()">{{ value | number }}</app-kpi-card>
@Component({
  standalone: false,
  selector: 'app-kpi-card',
  templateUrl: './kpi-card.component.html',
  styleUrls: ['./kpi-card.component.scss']
})
export class KpiCardComponent {

  @Input()
  label: string;

  // the question mark, hinting at an explanation
  @Input()
  info = true;

  @Input()
  clickable = false;

}
